import {
  SendOtpBodyType,
  SendOtpResponseType
} from "@website/widget/login/services/send-otp/send-otp.types";
import { BASE_URL_PROFILE } from "@website/widget/login/services/urls";
import { Axios } from "@website/widget/login/utils";
import { AxiosResponse } from "axios";

export const SendOtpUrl = `${BASE_URL_PROFILE}/auth/inquiry`;

export const SendOtpService = (
  body: SendOtpBodyType
): Promise<SendOtpResponseType> =>
  Axios.post(SendOtpUrl, body).then(
    ({ data }: AxiosResponse<SendOtpResponseType>) => data
  );
